import { useMemo } from 'react';
import { jsonLdScriptProps } from 'react-schemaorg';
import { useSeoDefaults } from '@funtech-int/yango-shared';

export const useSiteNameData = () => {
    const { hostOrigin, seoSiteName } = useSeoDefaults();

    return useMemo(
        () =>
            jsonLdScriptProps({
                '@context': 'https://schema.org',
                '@type': 'WebSite',
                name: seoSiteName,
                url: hostOrigin,
            }),
        [seoSiteName, hostOrigin]
    );
};
